export default __webpack_public_path__ + "static/media/home.2867e1f5.svg";